import React, { useRef, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import {
  MdOutlineKeyboardDoubleArrowRight,
  MdOutlineKeyboardArrowRight,
  MdOutlineKeyboardDoubleArrowLeft,
  MdOutlineKeyboardArrowLeft,
} from "react-icons/md";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import Footer from "../shared/Footer";
import config from "../../config";
import "react-toastify/dist/ReactToastify.css";
import { motion, AnimatePresence } from "framer-motion";

function DataNotFountListDetails12() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = sessionStorage.getItem("intermediateAdminToken");

  const { schoolCode, districtCode } = location.state || {};

  const [loading, setLoading] = useState(false);
  const [students, setStudents] = useState([]);
  const [status, setstaus] = useState("");
  const [id, setId] = useState("");

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const remarksRef = useRef(null);

  // Redirect if not logged in
  useEffect(() => {
    if (!token) navigate("/intermediate-admin");
  }, [token, navigate]);

  // Load students
  useEffect(() => {
    if (schoolCode && districtCode) {
      fetchStudents();
    }
  }, [schoolCode, districtCode]);

  // Fetch API
  const fetchStudents = async () => {
    try {
      setLoading(true);

      const response = await fetch(
        `${config.API_BASE_URL2}/AdminFetchDataNotFoundDistSCH_CL12`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            districtcode: districtCode,
            schooL_CODE: schoolCode,
          }),
        }
      );

      const data = await response.json();
      setLoading(false);

      if (data.status === 200) {
        const list = data.data.dataNotFoundSEC_list || [];
        setStudents(list); // store final list
      } else {
        console.error("API failed:", data.message);
      }
    } catch (error) {
      setLoading(false);
      console.error("API Error:", error);
    }
  };
  const closeRejectModal = () => {
    setShowRejectModal(false);
  };
  // SEARCH
  const filteredData = students.filter((s) => {
    const q = searchQuery.toLowerCase();
    return (
      s.candidatE_NAME?.toLowerCase().includes(q) ||
      s.dob?.includes(q) ||
      s.aadhaR_CARD?.includes(q) ||
      s.gender?.toLowerCase().includes(q) ||
      s.fatheR_NAME?.toLowerCase().includes(q) ||
      s.motheR_NAME?.toLowerCase().includes(q) ||
      s.registratioN_NO?.includes(q)
    );
  });

  // PAGINATION
  const totalPages = Math.ceil(filteredData.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handleSubmit = async (status, id) => {
    const remarks = remarksRef.current.value.trim();

    if (!remarks) {
      toast.warning(`Please provide remarks before ${status}.`);
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `${config.API_BASE_URL2}/UpdateDataNotFound_CL12`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: id,
            currenT_STATUS: status,
            remarks: remarksRef.current.value,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      setLoading(false);

      Swal.fire({
        icon: "success",
        // title: "Success",
        title: `SUCCESSFULLY ${
          status === "Resolve" ? "RESOLVED" : "REJECTED"
        } `,
        customClass: "custom-swal",
      }).then(() => {
        setStudents([]);
        fetchStudents();
      });

      setShowRejectModal(false);
    } catch (error) {
      setLoading(false); // Stop loader on error
      console.error("Error submitting:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };
  return (
    <div className="container-scroller">
      <ToastContainer position="top-right" autoClose={3000} />

      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}

      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />

        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 mb-3">
                <section className="content-header">
                  <h1>
                    <i className="fa fa-users" />
                    &nbsp; Students List (Data Not Found - Class XII)
                  </h1>
                  <ol className="breadcrumb">
                    <li>
                      <a
                        onClick={() =>
                          navigate("/intermediate-admin-dashboard")
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <i className="fa fa-tachometer" />
                        &nbsp; Home
                      </a>
                    </li>
                    <li className="active">Student List</li>
                  </ol>
                </section>
              </div>
            </div>

            <div className="row">
              <div className="card">
                <div className="card-body">
                  {/* ================= SEARCH + ROWS ================= */}
                  {students.length > 0 && (
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      {/* Rows */}
                      <div className="d-flex align-items-center">
                        <label className="me-2 mb-0">Rows:</label>
                        <select
                          className="form-select form-select-sm"
                          value={perPage}
                          onChange={(e) => {
                            setPerPage(Number(e.target.value));
                            setCurrentPage(1);
                          }}
                          style={{ width: "80px" }}
                        >
                          {[10, 20, 50, 100, 500].map((n) => (
                            <option key={n}>{n}</option>
                          ))}
                        </select>
                      </div>

                      {/* Search */}
                      <div style={{ width: "200px" }}>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Search..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                    </div>
                  )}

                  {/* ================= TABLE ================= */}
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead className="table-info">
                        <tr>
                          <th>Sl. No</th>
                          <th>Name</th>
                          <th>Gender</th>
                          <th>DOB</th>
                          <th>Father</th>
                          <th>Mother</th>
                          <th>Aadhaar</th>
                          <th>Registration No</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems.length > 0 ? (
                          currentItems.map((s, i) => (
                            <tr key={i}>
                              <td>{indexOfFirstItem + i + 1}</td>
                              <td>{s.candidatE_NAME}</td>
                              <td>{s.gender}</td>
                              <td>{s.dob}</td>
                              <td>{s.fatheR_NAME}</td>
                              <td>{s.motheR_NAME}</td>
                              <td>{s.aadhaR_CARD}</td>
                              <td>{s.registratioN_NO}</td>
                              <td>
                                {" "}
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm"
                                  onClick={() => {
                                    setShowRejectModal(true);
                                    setstaus("Resolve");
                                    setId(s.id);
                                  }}
                                >
                                  <i className="fa fa-check"></i>
                                  &nbsp;Resolve
                                </button>
                                &nbsp;
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    setShowRejectModal(true);
                                    setstaus("Reject");
                                    setId(s.id);
                                  }}
                                >
                                  <i className="fa fa-times"></i>
                                  &nbsp;Reject
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="9" className="text-center">
                              No records found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* ================= PAGINATION ================= */}
                  {students.length > 0 && (
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div>
                        Showing {(currentPage - 1) * perPage + 1} to{" "}
                        {Math.min(indexOfLastItem, filteredData.length)} of{" "}
                        {filteredData.length} entries
                      </div>

                      <div className="d-flex align-items-center gap-2">
                        <MdOutlineKeyboardDoubleArrowLeft
                          onClick={() => currentPage > 1 && setCurrentPage(1)}
                          style={{
                            cursor: currentPage > 1 ? "pointer" : "not-allowed",
                            opacity: currentPage > 1 ? 1 : 0.5,
                          }}
                        />

                        <MdOutlineKeyboardArrowLeft
                          onClick={() =>
                            currentPage > 1 && setCurrentPage((p) => p - 1)
                          }
                          style={{
                            cursor: currentPage > 1 ? "pointer" : "not-allowed",
                            opacity: currentPage > 1 ? 1 : 0.5,
                          }}
                        />

                        <span>
                          Page {currentPage} of {totalPages}
                        </span>

                        <MdOutlineKeyboardArrowRight
                          onClick={() =>
                            currentPage < totalPages &&
                            setCurrentPage((p) => p + 1)
                          }
                          style={{
                            cursor:
                              currentPage < totalPages
                                ? "pointer"
                                : "not-allowed",
                            opacity: currentPage < totalPages ? 1 : 0.5,
                          }}
                        />

                        <MdOutlineKeyboardDoubleArrowRight
                          onClick={() =>
                            currentPage < totalPages &&
                            setCurrentPage(totalPages)
                          }
                          style={{
                            cursor:
                              currentPage < totalPages
                                ? "pointer"
                                : "not-allowed",
                            opacity: currentPage < totalPages ? 1 : 0.5,
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <AnimatePresence>
              {showRejectModal && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    backdropFilter: "blur(8px)",
                    WebkitBackdropFilter: "blur(8px)",
                    zIndex: 1100,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <motion.div
                    initial={{ scale: 0.85, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.85, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    style={{
                      width: "95%",
                      maxWidth: "400px",
                      background: "#fff",
                      borderRadius: "12px",
                      overflow: "hidden",
                      boxShadow: "0 8px 30px rgba(0,0,0,0.2)",
                    }}
                  >
                    <div
                      className="modal-header bg-primary text-white"
                      style={{ padding: "10px" }}
                    >
                      <h5 className="modal-title">Give {status} Remarks :</h5>
                      <button
                        type="button"
                        className="btn close"
                        style={{ filter: "invert(1)" }}
                        onClick={closeRejectModal}
                      >
                        <i className="fa fa-times"></i>
                      </button>
                    </div>

                    <div className="modal-body" style={{ padding: "15px" }}>
                      <h5>Remarks:</h5>
                      <textarea
                        className="form-control"
                        rows={4}
                        ref={remarksRef}
                      ></textarea>
                    </div>

                    <div
                      className="modal-footer"
                      style={{ padding: "10px", display: "flex", gap: "5px" }}
                    >
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={closeRejectModal}
                      >
                        <i className="fa fa-times"></i>&nbsp;Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={() => handleSubmit(status, id)}
                      >
                        <i className="fa fa-save"></i>&nbsp;Save
                      </button>
                    </div>
                  </motion.div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          <Footer />
        </div>
      </div>
    </div>
  );
}

export default DataNotFountListDetails12;
